import type { RouteRecordRaw } from "vue-router";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { PATH_DASHBOARD } from "~/modules/dashboard/constants";

const routes: RouteRecordRaw[] = [
  {
    path: "",
    redirect: PATH_DASHBOARD,
  },
  // Landing route for all the users.
  {
    path: PATH_DASHBOARD,
    component: () => import("~/modules/dashboard/views/DashboardPage.vue"),
    meta: {
      // Do not check permissions in "can" callback here because
      // the redirection to the landing page route depending on the user's organization
      // is done later in the function `beforeEach` of the router (/src/plugins/router.ts).
      breadcrumb: BREADCRUMBS.DASHBOARD,
    },
  },
];

export default routes;
